import useApi from './useApi';
import { useAppContext } from '../store/AppContext';

const useRolesService = () => {
  const { api } = useApi();
  const [{ adminType }] = useAppContext();

  const getEstablishmentRoles = (establishmentId) => api({
    method: 'get',
    url: `/identity-access/v1/establishments/${establishmentId || 'own'}/establishment-roles`,
  });

  const getPlatformRoles = () => api({
    method: 'get',
    url: '/identity-access/v1/platform-roles',
  });

  const postRole = ({ type, role }) => {
    const pathByType = {
      platform: 'platform-roles',
      establishment: 'establishments/own/establishment-roles',
    };

    return api({
      method: 'post',
      url: `/identity-access/v1/${pathByType[type]}`,
      data: role,
    });
  };

  const putRole = ({ roleId, type, role }) => {
    const pathByType = {
      platform: 'platform-roles',
      establishment: 'establishments/own/establishment-roles',
    };

    return api({
      method: 'put',
      url: `/identity-access/v1/${pathByType[type]}/${roleId}`,
      data: role,
    });
  };

  const getAllPermissions = () => api({
    method: 'get',
    url: `/identity-access/v1/${adminType}-role-permissions`,
  });

  return {
    getEstablishmentRoles,
    getPlatformRoles,
    postRole,
    putRole,
    getAllPermissions,
  };
};

export default useRolesService;
